import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import NewsletterForm from "@/components/site/NewsletterForm";
import api from "@/lib/api";
import { saveCurrentAsReturnTo } from "@/lib/authRedirect";

export default function Footer() {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    api.get("/pages").then((r) => setPages(r.data)).catch(() => {});
  }, []);

  return (
    <footer data-testid="site-footer" className="mt-24 bg-[#0F1F3D] text-white/85">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <Link to="/" data-testid="footer-brand-logo" className="inline-flex items-center mb-4">
            <img
              src="/brand/tsr-logotype-white.png"
              alt="The School Reports"
              className="w-auto"
              style={{ height: "32px" }}
            />
          </Link>
          <p className="text-sm text-white/70 max-w-sm leading-relaxed mb-6">
            The Reports — panduan, analisis, dan cerita pendidikan untuk membantu orang tua Indonesia membuat keputusan yang lebih jernih.
          </p>
          <NewsletterForm />
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-white/55 mb-3">Jelajahi The School Reports</div>
          <ul className="space-y-2 text-sm text-white/90">
            <li><Link to="/" className="hover:text-[#E07A5F]" data-testid="footer-the-reports-link">The Reports</Link></li>
          </ul>
          <div className="mt-4 pt-4 border-t border-white/10 space-y-2 text-sm text-white/90" data-testid="footer-cta-links">
            <div><Link to="/register" onClick={saveCurrentAsReturnTo} className="hover:text-[#E07A5F] font-medium" data-testid="footer-register-link">Buat Akun</Link></div>
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-white/55 mb-3">Tentang</div>
          <ul className="space-y-2 text-sm text-white/90" data-testid="footer-pages-list">
            {pages.map((p) => (
              <li key={p.slug}>
                <Link to={`/halaman/${p.slug}`} data-testid={`footer-page-${p.slug}`} className="hover:text-[#E07A5F]">{p.title}</Link>
              </li>
            ))}
            <li>
              <Link to="/privacy-policy" data-testid="footer-privacy-policy" className="hover:text-[#E07A5F]">Kebijakan Privasi</Link>
            </li>
            <li>
              <Link to="/terms-of-service" data-testid="footer-terms-of-service" className="hover:text-[#E07A5F]">Syarat &amp; Ketentuan</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/55">
        © {new Date().getFullYear()} The School Reports — Wawasan pendidikan untuk orang tua Indonesia.
      </div>
    </footer>
  );
}
